export default class {
  constructor(namespace, homeUrl, nonce, lang = null) {
    this.namespace = namespace;
    this.homeUrl = homeUrl;
    this.nonce = nonce;
    this.lang = lang;
  }

  async get(path, params = {}, headers = {}, body = {}) {
    return this.request(path, "GET", headers, params, body);
  }

  async delete(path, params = {}, headers = {}, body = {}) {
    return this.request(path, "DELETE", headers, params, body);
  }

  async post(path, params = {}, headers = {}, body = {}) {
    return this.request(path, "POST", headers, params, body);
  }

  async request(path, method, headers = {}, params = {}, body = {}) {
    let init = {
      method,
      headers: {
        ...headers,
        ...{
          "X-WP-Nonce": this.nonce,
        },
      },
    };

    if (method !== "GET") {
      init.body = JSON.stringify({
        body,
      });
    }

    if (this.lang) {
      params.lang = this.lang;
    }

    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    if (query.length > 0) {
      query = "?" + query;
    }

    const response = await fetch(
      `${this.homeUrl}/wp-json/${this.namespace}/${path}${query}`,
      init
    );

    if (!response.ok) {
      throw new Error(`Error in ${path}! : ${response.statusText}`);
    }

    return response.json();
  }
}
